import { useEffect, useState } from 'react'
import { loadVoiceNote } from '@core/attachments'

/**
 * The note the sender spoke, on the card the admin is looking at.
 *
 * A plain audio element, because the browser's own controls are better than
 * anything worth building here and they already work with the phone's volume
 * buttons, its lock screen and its accessibility settings.
 *
 * Renders nothing when there is no note — which is most documents.
 */
export function VoicePlayer({ documentId }: { documentId: string }) {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    loadVoiceNote(documentId)
      .then((u) => alive && setUrl(u))
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [documentId])

  if (!url) return null

  return (
    <div className="mt-2">
      <p className="text-xs text-muted mb-1">Ingesproken bericht</p>
      <audio src={url} controls preload="none" className="w-full h-10" />
    </div>
  )
}
